import { FetchAPI_template } from "./FetchAPI_template";


export const Auth_Login = async(data) => {

    const url = `${process.env.REACT_APP_SERVER}api/v1/client/auth/register`;

    const method = "POST";
    const body = {
        name: "Admin of regix",
        email: data.email,
        password: data.password,
        project_id: process.env.REACT_APP_PROJECT_ID
    }
    
    const fetch_api_request = await FetchAPI_template(url,method,body);

    return fetch_api_request;

}
